/**
 * @fileoverview Back button: elements with [vdx-back-button] call history.back() on click or mouseup (one navigation per trigger).
 */

const BACK_BUTTON_SELECTOR = '[vdx-back-button]';

/** Attribute set when a button has been wired to avoid duplicate listeners. */
const WIRED_ATTR = 'vdx-wired';

/**
 * Wires one button: adds click and mouseup listeners that call history.back() and remove both listeners after one fires.
 * @param {Element} button
 */
function wireButton(button) {
    if (button.hasAttribute(WIRED_ATTR)) return;
    button.setAttribute(WIRED_ATTR, '');

    const handler = (event) => {
        event.preventDefault();
        if (typeof window !== 'undefined' && typeof window.history?.back === 'function') {
            window.history.back();
        }
        button.removeEventListener('click', handler);
        button.removeEventListener('mouseup', handler);
    };

    button.addEventListener('click', handler);
    button.addEventListener('mouseup', handler);
}

/**
 * Initializes back buttons: all [vdx-back-button] elements trigger history.back() on click or mouseup (once per trigger).
 * Safe to call multiple times (each button is wired at most once).
 */
export function backButtons() {
    if (typeof document === 'undefined') return;
    document.querySelectorAll(BACK_BUTTON_SELECTOR).forEach(wireButton);
}
